import { resolveRole } from "@/utils/deals.utils";
import { DEFAULT_ROLE_TAG_HEX, RESOLVED_ROLE_STYLES, ROLE_TAG_HEX } from "@/constant/deals.constant";

/**
 * The small colored role badge — "Buyer's agent", "Attorney", "Co-agent" —
 * used on checklist rows (whose job is this) and activity rows (who did
 * this). Shared by every deal-room portal so a client's activity feed and a
 * lender's task list tag roles identically.
 */
interface RoleTagPillProps {
  role: string;
  side?: string | null;
  hostDealType?: string;
  showSide?: boolean;
  isInternalHost?: boolean;
}

export function RoleTagPill({ role, side, hostDealType, showSide, isInternalHost }: RoleTagPillProps) {
  const resolved = resolveRole({ role, side, isInternalHost, hostDealType }) || role;
  const style = (RESOLVED_ROLE_STYLES as Record<string, { label: string }>)[resolved] || (RESOLVED_ROLE_STYLES as Record<string, { label: string }>)[role];
  const hex = (ROLE_TAG_HEX as Record<string, string>)[resolved] || (ROLE_TAG_HEX as Record<string, string>)[role] || DEFAULT_ROLE_TAG_HEX;
  if (!style) return null;
  return (
    <span
      className="flex-shrink-0 text-[9px] font-bold uppercase tracking-[0.5px] rounded px-1.5 py-0.5"
      style={{ backgroundColor: `${hex}1a`, color: hex }}
    >
      {style.label}
    </span>
  );
}
